module.exports = __webpack_public_path__ + "assets/icons/ic_background_update_24px.svg";